import CONFIG from '../../settings';
import type { AxiosError } from 'axios';

const urlLogout = `${CONFIG.oauthCropwiseUrl}/exit?continue=${globalThis.location.origin}`;

export function getRefreshToken(): string | null {
  return localStorage.getItem('refresh_token');
}

export function clearAuthData() {
  localStorage.clear();
  sessionStorage.clear();
}

export function buildAuthHeader(url: string, token: string): string {
  return url.includes('refresh_token') ? `Basic ${createBasicAuthHeader()}` : `Bearer ${token}`;
}

export const createBasicAuthHeader = () => {
  return btoa(`${CONFIG.oauthClientID}:${CONFIG.oauthClientSecret}`);
};

export const callLogoutSSO = () => {
  clearAuthData();
  globalThis.location.replace(urlLogout);
};

export function isTokenInvalid(error: AxiosError): boolean {
  const data = error.response?.data as { error?: string };
  return ['invalid_token', 'invalid_grant', 'Unauthorized'].includes(data?.error ?? '');
}
